// Column-resize helper for the workspace layout: attach startColumnDrag to a
// thin handle's mousedown; it tracks the pointer, clamps the width and
// persists it. Hosts own the width state (reactive) and bind it to
// flex-basis/width; double-click on the handle should reset via resetWidth.

export function loadStoredWidth(key, fallback) {
  try {
    var raw = localStorage.getItem("colWidth:" + key);
    var value = raw === null ? NaN : parseInt(raw, 10);
    return isNaN(value) ? fallback : value;
  } catch (e) {
    return fallback;
  }
}

export function storeWidth(key, value) {
  try {
    if (value === null || value === undefined) {
      localStorage.removeItem("colWidth:" + key);
    } else {
      localStorage.setItem("colWidth:" + key, String(Math.round(value)));
    }
  } catch (e) {
    /* private mode */
  }
}

// opts: { key, min, max, startWidth, invert?, onWidth(px), onEnd?(px) }
// invert: drag left edge (moving the pointer LEFT grows the column).
export function startColumnDrag(event, opts) {
  event.preventDefault();
  var startX = event.clientX;
  var startWidth = opts.startWidth;
  var lastWidth = startWidth;

  function clamp(value) {
    return Math.max(opts.min, Math.min(opts.max, value));
  }

  function onMove(e) {
    var delta = e.clientX - startX;
    if (opts.invert) delta = -delta;
    lastWidth = clamp(startWidth + delta);
    opts.onWidth(lastWidth);
  }

  function onUp() {
    document.removeEventListener("mousemove", onMove);
    document.removeEventListener("mouseup", onUp);
    document.body.style.userSelect = "";
    document.body.style.cursor = "";
    storeWidth(opts.key, lastWidth);
    if (opts.onEnd) opts.onEnd(lastWidth);
  }

  document.body.style.userSelect = "none";
  document.body.style.cursor = "col-resize";
  document.addEventListener("mousemove", onMove);
  document.addEventListener("mouseup", onUp);
}

export function resetWidth(key, fallback, onWidth) {
  storeWidth(key, null);
  onWidth(fallback);
}
